import React from "react";
import PropTypes from "prop-types";
import MSBCommunityChat from "./CommunityChat";
import EnableCommunityChat from "./EnableCommunityChat";

const CommunityChatWrapper = ({ api }, context) => {
  const { locals } = context;
  const { activeUserToRequest } = locals;
  const { pushAccountInfo } = activeUserToRequest;
  const userCanAccessToCommunityChat = pushAccountInfo?.inAppCommunityEnabled;

  return userCanAccessToCommunityChat ? (
    <MSBCommunityChat locals={locals} api={api} />
  ) : (
    <EnableCommunityChat />
  );
};

CommunityChatWrapper.propTypes = {
  api: PropTypes.any,
};

export default CommunityChatWrapper;
